<!-- Sidebar -->
<p-drawer [visible]="showStaffPreferenceSidebar()" (onHide)="close()" [showCloseIcon]="false" position="right" [dismissible]="false" [blockScroll]="false" styleClass="p-drawer w-12 lg:w-10 xl:w-9 staff-preference-sidebar no-header p-0">
  <ng-template #header>
    <!-- Header -->
    <div class="border-bottom-1 border-300 sticky left-0 top-0 w-full z-1 surface-0 flex align-items-center">
      <!-- Close Icon -->
      <div class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center -ml-1" (click)="close()">
        <i class="fa fa-times text-xl text-600"></i>
      </div>
      <!-- Close Icon -->
      <h4 class="mb-0 text-sm p-3">{{ 'STAFF.STAFF_PREFERENCE.PREFERENCE' | translate }}</h4>
    </div>
    <!-- Header -->
  </ng-template>

  <ng-template #content>
    <!-- Content -->
    <div class="md:flex">
      <!-- Left Side -->

      <div class="lg:w-4 xl:w-3 surface-0 px-3 pt-3 lg:pb-3 lg:min-h-screen">
        <ul class="list-none p-0 m-0 text-sm text-600 hidden lg:block white-space-nowrap overflow-x-auto">
          @for (preference of preferences; track preference) {
            <li
              class="flex align-items-center border-round p-2 md:p-3 cursor-pointer hover:surface-200 transition"
                        [ngClass]="{ 
                     'bg-primary': selectedPreferenceOption?.value === preference.value,
                     'opacity-40 pointer-events-none': preference.disabled 
                   }"
              (click)="selectPreferenceDesktop(preference)"
              >
              <i class="{{preference.icon}} mr-2"></i>
              <span>{{ 'STAFF.STAFF_PREFERENCE.' + preference.name | translate }}</span>
            </li>
          }
        </ul>

        <!-- Tabs For Tablet Down -->
        <p-select [options]="preferences" [(ngModel)]="selectedPreferenceOption" optionLabel="name" (onChange)="selectPreferenceMobile($event)" styleClass="w-full lg:hidden mb-3 text-sm" optionDisabled="disabled">
          <ng-template pTemplate="selectedItem">
            @if (selectedPreferenceOption) {
              <div class="flex align-items-center text-sm">
                <i class="{{selectedPreferenceOption.icon}} mr-2"></i>
                <span>{{ 'STAFF.STAFF_PREFERENCE.' + selectedPreferenceOption.name | translate }}</span>
              </div>
            }
          </ng-template>
          <ng-template let-preference pTemplate="item">
            <div class="flex align-items-center">
              <i class="{{preference.icon}} mr-2"></i>
              <span>{{ 'STAFF.STAFF_PREFERENCE.' + preference.name | translate }}</span>
            </div>
          </ng-template>
        </p-select>
        <!-- Tabs For Tablet Down -->
      </div>
      <!-- Left Side -->

      <!-- Right Side -->
      <div class="md:w-8 xl:w-9 surface-200 px-3">
        <!-- Profile -->
        @if (selectedPreference === staffPreferences.Profile || selectedPreference.toString() === staffPreferences[staffPreferences.Profile]) {
          <staff-profile />
        }
        <!-- Profile -->

        <!-- Notification -->
        @if (showNotification && (selectedPreference === staffPreferences.Notification || selectedPreference.toString() === staffPreferences[staffPreferences.Notification])) {
          <staff-notification />
        }
        <!-- Notification -->

        <!-- Availability -->
        @if (selectedPreference === staffPreferences.Availability || selectedPreference.toString() === staffPreferences[staffPreferences.Availability]) {
          <div class="shadow-3 surface-0 border-round p-4">
            @if (selectedPreference === staffPreferences.Availability || selectedPreference.toString() === staffPreferences[staffPreferences.Availability]) {
              <staff-availability [activeStaffId]="activeStaffId()" />
            }
          </div>
        }
        <!-- Availability -->

        <!-- My Commission -->
        @if (selectedPreference === staffPreferences.Commission || selectedPreference.toString() === staffPreferences[staffPreferences.Commission]) {
          <div class="shadow-3 surface-0 border-round p-4">
            @if (selectedPreference === staffPreferences.Commission || selectedPreference.toString() === staffPreferences[staffPreferences.Commission]) {
              <lib-my-commission />
            }
          </div>
        }
        <!-- My Commission -->
      </div>
      <!-- Right Side -->
    </div>
    <!-- Content -->
  </ng-template>
</p-drawer>
<!-- Sidebar -->
